export default "__VITE_ASSET__sd97mCKQ__"